export const iconFontAwesomeFoodBeveragePizzaSlice = (
	<i className="fa-solid fa-pizza-slice"></i>
);
